export function createDefaultAccountName() {
  const noun = getRandomItem(seedNouns)
  const adjective = getRandomItem(seedAdjectives)
  return `${adjective} ${noun}`
}

const seedAdjectives = [
  'Adventurous',
  'Bold',
  'Brave',
  'Charming',
  'Chic',
  'Cool',
  'Courageous',
  'Creative',
  'Curious',
  'Dedicated',
  'Determined',
  'Dynamic',
  'Elegant',
  'Enchanting',
  'Energetic',
  'Epic',
  'Ethereal',
  'Fresh',
  'Funky',
  'Futuristic',
  'Glamorous',
  'Glorious',
  'Graceful',
  'Iconic',
  'Innovative',
  'Intelligent',
  'Legendary',
  'Majestic',
  'Mythical',
  'Optimistic',
  'Organic',
  'Overwhelming',
  'Passionate',
  'Persistent',
  'Playful',
  'Punchy',
  'Radiant',
  'Radical',
  'Rare',
  'Resilient',
  'Revolutionary',
  'Sassy',
  'Sleek',
  'Sophisticated',
  'Spontaneous',
  'Stylish',
  'Trendy',
  'Unique',
  'Vibrant',
  'Visionary',
  'Whimsical',
  'Witty',
]

const seedNouns = [
  'Alfalfa',
  'Artichoke',
  'Branch',
  'Carrot',
  'Cucumber',
  'Earth',
  'Fiber',
  'Flower',
  'Fruit',
  'Grain',
  'Grass',
  'Herb',
  'Ladybug',
  'Leaf',
  'Meal',
  'Plant',
  'Planter',
  'Rhizome',
  'Root',
  'Rose',
  'Seedling',
  'Ship',
  'Soil',
  'Sprout',
  'Staple',
  'Stem',
  'Tree',
  'Vegetable',
]

function getRandomItem(array: string[]): string {
  return array[Math.floor(Math.random() * array.length)]!
}
